import React from 'react';
import { DiscountIcon } from '../../Icons';
import { SpecialOffer } from './SpecialOffer';
import styles from './SpecialOffer.module.scss';
import { specialOfferDummy } from '../../_dummyData';

export const SpecialOfferModalBody: React.FC = () => (
    <>
        <div className={styles.banner}>
            <div className={styles.bannerTitle}>
                <h2>СКИДКА - 50%</h2>
                <h3>Лицензия «Оптимальные условия»</h3>
                <h4>
                    Дает скидку при подаче заявки на закупки
                    <br />
                    (1 % от НМЦ, не менее 7 500 руб. и не более 175 000 руб.)
                </h4>
            </div>
            <div className={styles.bannerLogo}>
                <DiscountIcon />
            </div>
        </div>
        <div className={styles.specialOffer}>
            <SpecialOffer {...specialOfferDummy} />
        </div>
    </>
);
